import React from 'react';

export default class AsyncAvailabilityModal extends React.Component {
  state = { Component: null };

  componentDidMount() {
    this._mounted = true;
    import('./index').then(module => {
      if (this._mounted) {
        this.setState({ Component: module.default });
      }
    });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    const { Component } = this.state;
    return Component ? <Component /> : null;
  }
}
